<template>
  <div class="main-content">
    <a-t-loader v-if="isLoadComponent"/>

    <template v-else>
      <div class="page-content">
        <div class="container">
          <section class="change-invoice">
            <div class="page-title">
              <h2>Create invoice</h2>
              <div class="btn-back">
                <router-link :to="{ name: 'client', params: { id: currentInvoice.clientId }}" class="btn btn--silver">
                  <svg width="1em" height="1em" class="icon icon-collapse">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#back"></use>
                  </svg>
                  <span>Back to Program</span>
                </router-link>
              </div>
            </div>
            <div class="page-body">
              <div class="information-block js-collapse" :class="{'is-collapsed': collapse.information}">
                <div class="information-block_header">
                  <div class="information-block_title">
                    <span>Group Information</span>
                  </div>
                  <div class="information-block_hide">
                    <button
                        type="button"
                        data-opened="Hide"
                        data-closed="Show"
                        :class="[
                      'btn',
                      'btn--collapse',
                      'js-collapse-trigger',
                      {'is-active': collapse.information},
                    ]"
                        @click="collapse.information = !collapse.information">
                      <div class="btn--collapse__icon">
                        <svg width="1em" height="1em" class="icon icon-collapse">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>

                <div
                    id="total-sect"
                    :class="['make-story__collapse js-collapse summary-section']"
                    v-if="calculationResult">
                  <div
                      class="make-story__collapse__inner  js-collapse-inner"
                      v-if="calculationResult">
                    <div class="breakdown-cost__pax">
                      <span class="breakdown-cost__pax-name">Pax:</span>
                      <span class="breakdown-cost__pax-desc">{{participantsPax.length}} </span>
                      <span class="breakdown-cost__pax-desc">(</span>
                      <span v-for="(item, index) in participantsPax" :key="index" class="breakdown-cost__pax-desc">
                      {{ item }}
                    </span>
                      <span class="breakdown-cost__pax-desc">)</span>
                    </div>

                    <div class="breakdown-cost__result">
                      <div class="summary-result_item">
                        <span class="summary-result_item-name">Total Amount:</span>
                        <div class="line"></div>
                        <span class="summary-result_item-total">
                        {{
                            getCurrencySign(currentInvoice.currencyType)
                          }}
                        {{numberWithCommas(currentInvoice.totalAmount)}}
                        </span>
                      </div>
                      <div class="summary-result_item">
                        <span class="summary-result_item-name">Amount Paid:</span>
                        <div class="line"></div>
                        <span class="summary-result_item-total">{{
                            getCurrencySign(currentInvoice.currencyType)
                          }}
                        {{numberWithCommas(currentInvoice.amountPaid)}}</span>
                      </div>
                      <div class="summary-result_item">
                        <span class="summary-result_item-name">Remain Balance:</span>
                        <div class="line"></div>
                        <span class="summary-result_item-total">{{
                            getCurrencySign(currentInvoice.currencyType)
                          }}
                        {{numberWithCommas(currentInvoice.remainAmount)}}</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bank-block">
                <div class="bank-block_title">
                  <span>Bank</span>
                </div>

                <div class="bank-block_selects">
                  <v-select
                      v-model="templateCurrentInvoice.bankId"
                      :options="availableBanks"
                      :reduce="(item) => item.id"
                      @input="findCurrentBankSelect()"
                      :filterable="false"
                      :clearable="false"
                      :searchable="false"
                      :disabled="!hasClientContract"
                      label="shortName"
                      placeholder="Select bank"
                      class="new-select"
                      :class="{'invoice-bank-select--error': validErrorInvoice.bank}"
                  >
                    <template #open-indicator>
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="5"
                          viewBox="0 0 8 5"
                          fill="none">
                        <path
                            d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                            fill="#606060" />
                      </svg>
                    </template>
                    <template #option="option">
                      <div class="select__item d-center">
                        {{ option.shortName }}
                      </div>
                    </template>
                    <template #selected-option="option">
                      <div class="selected d-center">
                        {{ option.shortName }}
                      </div>
                    </template>
                  </v-select>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Beneficiary</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name content-block_name-fw">
                      <span>IBAN Account:</span>
                      <span>{{ currentBankSelect.ibanAccount }}</span>
                    </div>
                    <div class="content-block_name content-block_name-fw">
                      <span>Company Name:</span>
                      <span>{{ currentBankSelect.companyName }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Company Address: </span>
                      <span>{{ currentBankSelect.beneficiaryAddress }}</span>
                    </div>
                  </div>
                </div>

                <div class="bank-block_content">
                  <div class="content-block">
                    <span class="content-block_title">Bank of Beneficiary</span>
                  </div>
                  <div class="content-block">
                    <div class="content-block_name content-block_name-fw">
                      <span>SWIFT:</span>
                      <span>{{ currentBankSelect.swift }}</span>
                    </div>
                    <div class="content-block_name content-block_name-fw">
                      <span>Bank Name:</span>
                      <span>{{ currentBankSelect.name }}</span>
                    </div>
                    <div class="content-block_name">
                      <span>Bank Address:</span>
                      <span>{{ currentBankSelect.bankAddress }}</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="payer-block">
                <div class="payer-block_title">
                  <span>Payer</span>
                </div>
                <div class="payer-block_control">
                  <div class="payer-block_control-panel">
                    <div class="control-panel_selects">
                      <v-select
                          v-model="templateCurrentInvoice.payer.payerType"
                          :options="payerOptions"
                          :reduce="(item) => item.type"
                          @input="findCurrentPayerOptionsSelect()"
                          :filterable="false"
                          :clearable="false"
                          :searchable="false"
                          label="name"
                          placeholder="Select bank"
                          class="new-select"
                      >
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060" />
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="select__item d-center">
                            {{ option.name}}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="selected d-center">
                            {{ option.name }}
                          </div>
                        </template>
                      </v-select>

                      <div
                          v-if="currentPayerOptionsSelect.payerType === 'OPERATOR'"
                          class="form-control-group">
                        <v-select
                            v-model="currentPayerSelect"
                            :options="allPartners"
                            :reduce="(item) => item"
                            @input="findCurrentPayerSelect()"
                            :filterable="false"
                            :clearable="false"
                            :searchable="false"
                            label="companyName"
                            placeholder=""
                            class="new-select new-select--partners"
                        >
                          <template #open-indicator>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="8"
                                height="5"
                                viewBox="0 0 8 5"
                                fill="none">
                              <path
                                  d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                  fill="#606060" />
                            </svg>
                          </template>
                          <template #option="option">
                            <div class="select__item d-center">
                              {{ option.companyName}}
                            </div>
                          </template>
                          <template #selected-option="option">
                            <div class="selected d-center">
                              {{ option.companyName }}
                            </div>
                          </template>
                        </v-select>
                      </div>

                      <div
                          v-if="currentPayerOptionsSelect.payerType === 'PARTICIPANT'"
                          class="form-control-group form-control-group_clients">

                        <input type="text" class="form-control" placeholder="Введите имя" v-model="templateCurrentInvoice.payer.participant">

                      </div>

                    </div>
                    <div class="control-panel_description">
                      <div class="description-currency">
                        <span class="name">Currency: </span>
                        <span class="value">{{getCurrencySign(templateCurrentInvoice.currencyType)}}</span>
                        <span class="value currency">{{ templateCurrentInvoice.currencyType }}</span>
                      </div>
                      <div class="description-date">
                        <span>Deadline:</span>
                        <div class="form-control-wrap" :class="{'is-error': validErrorInvoice.deadline}">
                          <input
                              type="text"
                              placeholder="Date"
                              v-model="templateCurrentInvoice.deadline"
                              @blur="
                            convectorFormat($event.target.value, 'deadline')
                          "
                              class="form-control js-datepicker-single" />
                          <div class="form-control-icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-calendar">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-if="(currentPayerOptionsSelect.payerType === 'OPERATOR') && (currentPayerSelect.tin.length !== 0 || currentPayerSelect.vrn.length !== 0 || currentPayerSelect.phone.length !== 0 || currentPayerSelect.address.length !== 0)"
                      class="payer-block_control-content">
                    <div class="control-content_block">
                      <span>TIN:</span>
                      <span>{{ currentPayerSelect.tin }}</span>
                    </div>
                    <div class="control-content_block">
                      <span>VRN:</span>
                      <span>{{ currentPayerSelect.vrn }}</span>
                    </div>
                    <div class="control-content_block">
                      <span>Mobile:</span>
                      <span>{{ currentPayerSelect.phone }}</span>
                    </div>
                    <div class="control-content_block">
                      <span>Address:</span>
                      <span>{{ currentPayerSelect.address }}</span>
                    </div>
                  </div>
                </div>
                <div class="payer-block__behalf">
                  <div class="payer-block_title">
                    <span>Behalf of</span>
                  </div>

                  <div
                      :class="['select-wrapper', {'is-active': selects.clients}]"
                      style="max-width: 240px"
                      @click="openSelects('clients')"
                  >
                    <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        templateCurrentInvoice.behalfOf.length > 0 && templateCurrentInvoice.behalfOf.length !== behalfList.length
                            ? templateCurrentInvoice.behalfOf.map((p) => p.participantName).join(', ')
                            : 'All Clients'
                      }}
                    </span>
                      <span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                      </svg>
                    </span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div class="select-option">
                          <label
                              class="form-control-checkbox form-control-checkbox-add-flight"
                              @click.prevent.stop="templateCurrentInvoice.behalfOf = behalfList"
                          >
                            <input
                                type="checkbox"
                                :checked="templateCurrentInvoice.behalfOf.length === behalfList.length"
                            />
                            <span class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg>
                          </span>
                            <span class="select-option__name">All Clients</span>
                          </label>
                        </div>
                        <div
                            v-for="p in behalfList"
                            :key="p.id"
                            :class="[
                          'select-option',
                          {
                            'is-selected': false
                          },
                        ]">
                          <label
                              class="form-control-checkbox form-control-checkbox-add-flight"
                              @click.prevent.stop="() => {
                                  if(templateCurrentInvoice.behalfOf.length === behalfList.length){
                                    templateCurrentInvoice.behalfOf = []
                                  }
                                  if (!templateCurrentInvoice.behalfOf.map((item) => item.participantId).includes(p.participantId)) {
                                      templateCurrentInvoice.behalfOf.push({
                                        id: p.id,
                                        participantId: p.participantId,
                                        participantName: p.participantName
                                      })
                                  } else {
                                    templateCurrentInvoice.behalfOf = templateCurrentInvoice.behalfOf.filter((i) => !(i.participantId === p.participantId))
                                  }
                              }">
                            <input
                                type="checkbox"
                                :checked="
                                templateCurrentInvoice.behalfOf.length === behalfList.length ? false : templateCurrentInvoice.behalfOf.map((item) => item.participantId).includes(p.participantId)
                              "
                                @click.prevent.stop />
                            <span
                                class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg>
                          </span>
                            <span class="select-option__name">{{p.participantName}}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="behalf__clients-pax">
                    <span class="clients-pax__title">Clients ({{templateCurrentInvoice.behalfOf.length}} Pax): </span>

                    <span
                        class="clients-pax__disc"
                        v-for="(p, index) in templateCurrentInvoice.behalfOf"
                        :key="p.participantId"
                        :class="{'participant--deleted': p.warn}"

                    >
                      {{p.participantName}}<template v-if="templateCurrentInvoice.behalfOf.length !== index + 1">,</template><template v-if="p.warn">(Deleted)</template>
                    </span>
                  </div>
                </div>
                <div class="payment-on-spot__checkbox-wrapper">
                  <div class="form-control-group form-control-group--radio">
                    <label
                        class="form-control-radio"
                        @click="templateCurrentInvoice.chargeType = 'STANDARD'">
                      <input
                          type="radio"
                          name="payment-options"
                          value="standard"
                          :checked="templateCurrentInvoice.chargeType === 'STANDARD'" />
                      <span class="form-control-radio__box"></span
                      ><span class="form-control-radio__name"
                    >Standard</span
                    >
                    </label>
                    <label
                        class="form-control-radio"
                        @click="templateCurrentInvoice.chargeType = 'SPOT'">
                      <input
                          type="radio"
                          name="payment-options"
                          value="paymentOnSpot"
                          :checked="templateCurrentInvoice.chargeType === 'SPOT'" />
                      <span
                          class="form-control-radio__box"></span
                      ><span class="form-control-radio__name"
                    >Payment on spot</span
                    >
                    </label>
                    <label
                        v-if="client.contract !== 'UAE'"
                        class="form-control-radio"
                        @click="templateCurrentInvoice.chargeType = 'AUTH_FORM'">
                      <input
                          type="radio"
                          name="payment-options"
                          value="authorizationForm"
                          :checked="templateCurrentInvoice.chargeType === 'AUTH_FORM'" /><span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                    >Authorization form</span
                    >
                    </label>
                  </div>
                </div>
                <div class="payer-block_services">
                  <div class="payer-block_services-header">
                    <div class="services-header_title">
                      <span>Description of Services</span>
                    </div>
                    <div class="services-header_qty">
                      <span>Qty</span>
                    </div>
                    <div class="services-header_price">
                      <span>Price</span>
                    </div>
                    <div class="services-header_date">
                      <span>Dates</span>
                    </div>
                    <div class="services-header_amount">
                      <span>Amount</span>
                    </div>
                    <div class="services-header_amount">
                      <span>To be paid</span>
                    </div>
                    <div class="services-header_deleted"></div>
                  </div>
                  <draggable v-model="templateCurrentInvoice.services" handle=".movethis" @end="autoresizeAllTextarea()">
                  <div v-for="(services, index) in templateCurrentInvoice.services" :key="services.id" class="payer-block_services-body">
                    <div class="services-body_select">
                      <v-select
                          v-model="services.type"
                          :options="categoriesServicesBreakdown"
                          :reduce="(item) => item.type"
                          :filterable="false"
                          :clearable="false"
                          @input="changeServiceNameByType(services)"
                          :searchable="false"
                          label="name"
                          placeholder=""
                          class="new-select"
                      >
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060" />
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="select__item d-center">
                            <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                            >
                            <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                            >
                            <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                            >
                            <svg v-if="option.type === 'TRANSFER'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                            >
                            <svg v-if="option.type === 'FLIGHT'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                            >
                            <svg v-if="option.type === 'MAINLAND'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                            >
                            <svg v-if="option.type === 'ISLAND' || option.type === 'ISLAND_TRANSFER' || option.type === 'ISLAND_DAY_TRIP'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                            >
                            <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                            >
                            <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                            >
                            <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                            >
                            {{ option.name }}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="selected d-center">
                            <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                            >
                            <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                            >
                            <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                            >
                            <svg v-if="option.type === 'TRANSFER'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                            >
                            <svg v-if="option.type === 'FLIGHT'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                            >
                            <svg v-if="option.type === 'MAINLAND'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                            >
                            <svg v-if="option.type === 'ISLAND' || option.type === 'ISLAND_TRANSFER' || option.type === 'ISLAND_DAY_TRIP'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                            >
                            <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                            >
                            <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                            >
                            <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                 width="20px"
                                 height="20px"
                                 class="icon icon-categories">
                              <use
                                  xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                            >
<!--                            <span>{{ option.name }}</span>-->
                          </div>
                        </template>
                      </v-select>

                    </div>
                    <div class="services-body_description">
                      <div class="form-control-wrap" :class="{'is-error': !templateCurrentInvoice.services[index].name.length > 0 || templateCurrentInvoice.services[index].isError}">
                        <textarea type="text" data-textarea-autoresize resize="none" wrap="soft" class="resizable-textarea" @input="textAreaAutoSize($event)" placeholder="note" v-model="templateCurrentInvoice.services[index].name" />
                      </div>
                    </div>
                    <div class="services-body_qty">
                      <div class="form-control-wrap">
                        <the-mask
                            type="text"
                            class="form-control form-control-time maskField"
                            :mask="'##'"
                            :tokens="{'#': {pattern: /[A-Za-z0-9]/}}"
                            v-model="templateCurrentInvoice.services[index].quantity"
                            @input="findCurrentSelectsQuality(services, templateCurrentInvoice)"
                            placeholder="1" />
                      </div>
                    </div>
                    <div class="services-body_price">
                      <div class="form-control-wrap">
                        <span>{{getCurrencySign(templateCurrentInvoice.currencyType)}}</span>
                        <input @input="onCountPrice(services, templateCurrentInvoice, totalAmountCurrentInvoice)" type="number" class="form-control" placeholder="0" v-model="templateCurrentInvoice.services[index].price">
                      </div>
                    </div>
                    <div class="services-body_date" :class="{'valid-error': !(parseDate(templateCurrentInvoice.services[index].startDate) <= parseDate(templateCurrentInvoice.services[index].endDate))}">
                      <div class="form-control-wrap first">
                        <input
                            type="text"
                            placeholder="From"
                            v-model="templateCurrentInvoice.services[index].startDate"
                            @blur="
                            templateCurrentInvoice.services[index].startDate = $event.target.value
                          "
                            class="form-control js-datepicker-single" />
                      </div>
                      <span>-</span>
                      <div class="form-control-wrap second">
                        <input
                            type="text"
                            placeholder="To"
                            v-model="templateCurrentInvoice.services[index].endDate"
                            @blur="
                            templateCurrentInvoice.services[index].endDate = $event.target.value
                          "
                            class="form-control js-datepicker-single"
                        />
                        <div class="form-control-icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-calendar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="services-body_amount">

                      <template v-if="templateCurrentInvoice.services[index].amount">
                        <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                        <span>{{templateCurrentInvoice.services[index].amount === null ? ' - ' : numberWithCommas(templateCurrentInvoice.services[index].amount)}}</span>
                      </template>

                    </div>
                    <div class="services-body_payable">
                      <div class="form-control-wrap">
                        <span>{{getCurrencySign(templateCurrentInvoice.currencyType)}}</span>
                        <input
                            @input="onCountPayable(services, templateCurrentInvoice, index)"
                            type="number"
                            class="form-control"
                            :placeholder="0"
                            v-model="templateCurrentInvoice.services[index].amountPayable"
                        >
                      </div>
                    </div>
                    <div class="movethis-wrapper">
                      <button
                          type="button"
                          class="movethis-button movethis">
                        <svg width="1em" height="1em" class="icon icon-movethis">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-move"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="services-body_delete">
                      <button
                          type="button"
                          class="btn btn--remove"
                          @click="deleteServices(index, services, templateCurrentInvoice)"
                      >
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                  </draggable>
                  <div class="payer-block_services-options">
                    <div class="services-options_btn">
                      <button
                          type="button"
                          class="btn btn--rounded2 btn--green btn--add"
                          @click="addServices"
                      >
                        <svg width="1em" height="1em" class="icon icon-plus-o-white">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                        </svg>
                        <span>Add Services</span>
                      </button>
                    </div>
                    <div class="">
                      <div class="services-options__block">
                        <div class="services-options_deposit">
                          <div class="deposit-name">
                            <span>Current Deposit:</span>
                          </div>
                          <div class="deposit-current">
                            <div
                                :class="[
                            'form-control-wrap form-control-wrap--days',
                            {'is-error': false},
                          ]">
                              <input
                                  type="number"
                                  :placeholder="templateCurrentInvoice.currentDeposit"
                                  @input="templateCurrentInvoice.currentDeposit = $event.target.value === '' ? 0 : $event.target.value"
                                  :value="templateCurrentInvoice.currentDeposit"
                                  class="form-control" />
                              <div class="form-control-label-descr">
                            <span>
                              {{getCurrencySign(templateCurrentInvoice.currencyType)}}
                            </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="services-options__block--separator"></div>
                        <div v-if="false" class="services-options_paymentMethod">
                          <span>Payment Method</span>
                          <div class="paymentMethod__block">
                            <div class="paymentMethod__block-select">
                              <v-select
                                  v-model="templateCurrentInvoice.paymentMethod"
                                  :options="paymentMethodSelect"
                                  :reduce="(item) => item.type"
                                  :filterable="false"
                                  :clearable="false"
                                  :searchable="false"
                                  label="name"
                                  placeholder="Select service"
                                  class="new-select"
                              >
                                <template #open-indicator>
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="8"
                                      height="5"
                                      viewBox="0 0 8 5"
                                      fill="none">
                                    <path
                                        d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                        fill="#606060" />
                                  </svg>
                                </template>
                                <template #option="option">
                                  <div class="select__item d-center">
                                    <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                                    >
                                    <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                                    >
                                    <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                                    >
                                    <svg v-if="option.type === 'TRANSFER'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                                    >
                                    <svg v-if="option.type === 'FLIGHT'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                                    >
                                    <svg v-if="option.type === 'MAINLAND'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                                    >
                                    <svg v-if="option.type === 'ISLAND' || option.type === 'ISLAND_TRANSFER' || option.type === 'ISLAND_DAY_TRIP'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                                    >
                                    <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                                    >
                                    <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                                    >
                                    <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                                    >
                                    {{ option.name }}
                                  </div>
                                </template>
                                <template #selected-option="option">
                                  <div class="selected d-center">
                                    <svg v-if="option.type === 'CUSTOM' || option.type === 'ADDITIONAL_OPTION'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#custom"></use></svg
                                    >
                                    <svg v-if="option.type === 'OTHER_EXPENSES' || option.type === 'ADDITIONAL_SERVICE'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#other"></use></svg
                                    >
                                    <svg v-if="option.type === 'AIRPORT_VIP_SERVICE'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#airport-services"></use></svg
                                    >
                                    <svg v-if="option.type === 'TRANSFER'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#transfers"></use></svg
                                    >
                                    <svg v-if="option.type === 'FLIGHT'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#flight-tickets"></use></svg
                                    >
                                    <svg v-if="option.type === 'MAINLAND'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#day-trip"></use></svg
                                    >
                                    <svg v-if="option.type === 'ISLAND'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#island"></use></svg
                                    >
                                    <svg v-if="option.type === 'SAFARI' || option.type === 'SAFARI_ACTIVITY'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#safari"></use></svg
                                    >
                                    <svg v-if="option.type === 'CLIMBING' || option.type === 'CLIMBING_RENTAL' || option.type === 'CLIMBING_EXTRA'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#climbing"></use></svg
                                    >
                                    <svg v-if="option.type === 'EXTRA_ACCOMMODATION'"
                                         width="20px"
                                         height="20px"
                                         class="icon icon-categories">
                                      <use
                                          xlink:href="/images/icons/invoices/invoices-sprite.svg#extra-accommodation"></use></svg
                                    >
                                    {{ option.name }}
                                  </div>
                                </template>
                              </v-select>
                            </div>
                            <div class="paymentMethod__block-date">
                              <div class="form-control-wrap">
                                <input
                                    type="text"
                                    placeholder="Date"
                                    v-model="templateCurrentInvoice.dateOfPayment"
                                    @blur="
                            convectorFormat($event.target.value, 'dateOfPayment')
                          "
                                    class="form-control js-datepicker-single" />
                                <div class="form-control-icon">
                                  <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-calendar">
                                    <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="services-options_total">
                          <div class="total-name">
                            <span>Total amount:</span>
                          </div>
                          <div class="total-line"></div>
                          <div class="total-result">
                            <template v-if="totalAmountCurrentInvoice">
                              <span>
                                {{getCurrencySign(currentInvoice.currencyType)}}
                                {{totalAmountCurrentInvoice === null ? '' : sumTotalInvoice(templateCurrentInvoice)}}
                              </span>
                            </template>
                            <template v-else>
                              <span>0</span>
                            </template>
                          </div>
                        </div>
                        <div class="services-options_payable">
                          <div class="total-name">
                            <span>Amount Payable:</span>
                          </div>
                          <div class="total-line"></div>
                          <div class="total-result">
                            <template v-if="templateCurrentInvoice.totalAmountPayable">
                              <span>
                                {{getCurrencySign(templateCurrentInvoice.currencyType)}}
                                {{templateCurrentInvoice.totalAmountPayable === null ? '' : numberWithCommas(templateCurrentInvoice.totalAmountPayable)}}
                              </span>
                            </template>
                            <template v-else>
                              <span>0</span>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div
                          class="breakdown-cost__summary__total__main breakdown-cost__summary__total__main_2">
                        <div class="breakdown-cost__summary__text-swich">
                          Allow the client to pay for the tour via Stripe, turn it
                          ON only when all hotels have confirmed your pre-booking.
                        </div>
                        <div class="switch">
                          <label class="switch-label"
                          ><input type="checkbox" v-model="templateCurrentInvoice.allowStripe" />
                            <span class="switch-inp"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="payer-block_services-footer">
                    <div class="services-footer_desc">
                      <span>Note: Bank commissions of the Payer's and Receiver's bank are payable by the Payer.</span>
                      <span>By paying this bill, you are accepting our Terms and Conditions: <a target="_blank" href="https://altezza.travel/en/terms-and-conditions">https://altezza.travel/en/terms-and-conditions</a></span>
                    </div>
                    <div class="services-footer_confirm">
                      AMOUNT PAYABLE:
                      <template v-if="templateCurrentInvoice.totalAmountPayable">
                        <span>{{getCurrencySign(currentInvoice.currencyType)}}</span>
                        <span>{{templateCurrentInvoice.totalAmountPayable === null ? '' : numberWithCommas(templateCurrentInvoice.totalAmountPayable)}}</span>
                      </template>
                      <template v-else>
                        0
                      </template>
                      should be paid before
                      <template v-if="templateCurrentInvoice.deadline">
                        {{templateCurrentInvoice.deadline === null ? '' : parseDateToString(templateCurrentInvoice.deadline)}}
                      </template>
                      <template v-else>
                        ( Веберете дату )
                      </template>
                      in order to confirm your booking.
                    </div>
                    <div class="services-footer_note">
                      <div class="note-title">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <span>NOTE</span>
                      </div>
                      <div class="note-text">
                        <textarea type="text" placeholder="Type a note" v-model="templateCurrentInvoice.note"/>
                      </div>
                    </div>
                    <div class="services-footer_btn">
                      <router-link :to="{ name: 'client', params: { id: currentInvoice.clientId }}" class="btn btn--silver">
                        <svg width="1em" height="1em" class="icon icon-collapse">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#back"></use>
                        </svg>
                        <span>Back to Program</span>
                      </router-link>
                      <span v-if="!hasClientContract" class="invoice-contract-error">
                        The program contract type is missing.
                      </span>
                      <button
                          type="button"
                          :disabled="!hasClientContract"
                          @click="createDublicateInvoices"
                          class="btn btn--green">
                        <span>Create Invoice</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vuex from "vuex";
import {TheMask} from 'vue-the-mask'

import ATLoader from "@/components/Loaders/Loader";
import {actionTypes as actionTypesInvoice, getterTypes as getterTypesInvoice} from "@/store/modules/invoices";
import {actionTypes as actionTypesSettings, getterTypes as getterTypesSettings} from "@/store/modules/settings";
import {actionTypes as actionTypesBanks, getterTypes as getterTypesBanks} from "@/store/modules/banks";
import {actionTypes as actionTypesPartners, getterTypes as getterTypesPartners} from "@/store/modules/partners";
import {debounce} from "lodash";
import Lightpick from "lightpick";
import draggable from "vuedraggable";
import {format, parse} from "date-fns";
import {getPlaceholderTemplates} from "@/common/helpers/invoiceServicePlaceholders";
import {getCurrencySign} from '@/common/helpers/currency'
import {getBanksByContractType} from '@/common/helpers/banks'
export default {
  name: 'CreateDubliсateInvoice',
  data(){
    return {
      placeholderTemplates: getPlaceholderTemplates(),
      now: Date.now(),
      isLoadComponent: true,
      collapse: {
        information: false,
      },
      selects: {
        bank: false,
        clients: false,
      },
      isActiveSelectBank: false,
      currentBankSelect: {},
      currentPayerOptionsSelect: '',
      isActiveSelectPayerOptions: false,
      allowStripe: false,
      totalAmountCurrentInvoice: 0,
      paymentMethodSelect: [
        {name: 'NONE', type: null},
        {name: 'Stripe', type: 'STRIPE'},
        {name: 'Kassa', type: 'KASSA'},
        {name: 'NMB', type: 'NMB'},
        {name: 'Exim', type: 'EXIM'},
        {name: 'Equity', type: 'EQUITY'},
        {name: 'CRDB', type: 'CRDB'},
        {name: 'Paypal', type: 'PAYPAL'},
        {name: 'Crypto', type: 'CRYPTO'},
        {name: 'Cash', type: 'CASH'},
      ],
      validErrorInvoice: {
        deadline: true,
        price: true,
        date: true,
        bank: false,
      },
      templateCurrentInvoice: {
        currencyType: "",
        clientId: null,
        bankId: null,
        userId: null,
        currentDeposit: 0,
        behalfOf: [],
        status: 'SENT',
        paymentMethod: null,
        dateOfPayment: '',
        allowStripe: false,
        payer: {
          payerType: "",
          participant: "",
          operatorId: null
        },
        note: "",
        deadline: "",
        services: [],
        chargeType: 'STANDARD',
      },
      isActiveSelectPayer: false,
      currentPayerSelect: {},
      payerOptions: [
        {
          type: 'OPERATOR',
          name: 'Operator',
        },
        {
          type: 'PARTICIPANT',
          name: 'Client',
        },
      ],
    }
  },
  components: {ATLoader, TheMask, draggable},
  computed: {
    ...Vuex.mapGetters({
      currentInvoice: getterTypesInvoice.currentInvoice,
      isLoadingCurrentInvoice: getterTypesInvoice.isLoadingCurrentInvoice,
      isLoadingClient: getterTypesSettings.isLoadingClient,
      isLoadingAllBanks: getterTypesBanks.isLoadingAllBanks,
      isLoadingAllPartners: getterTypesPartners.isLoadingAllPartners,
      client: getterTypesSettings.client,
      calculationResult: getterTypesSettings.calculationResult,
      participants: getterTypesSettings.participants,
      allBanks: getterTypesBanks.allBanks,
      allPartners: getterTypesPartners.allPartners,
      categoriesServicesBreakdown: getterTypesSettings.categoriesServicesBreakdown,
      upCurrentInvoice: getterTypesInvoice.upCurrentInvoice,
      isLoadingChangeCurrentInvoice: getterTypesInvoice.isLoadingChangeCurrentInvoice,
      newInvoices: getterTypesInvoice.newInvoices,
      behalfList: getterTypesInvoice.behalfList
    }),
    hasClientContract() {
      return Boolean(this.client && this.client.contract)
    },
    availableBanks() {
      return getBanksByContractType(this.allBanks, this.client && this.client.contract)
          .filter((bank) => Array.isArray(bank.availableCurrencies) &&
              bank.availableCurrencies.includes(this.templateCurrentInvoice.currencyType))
    },
    sorteredParticipants() {
      if (this.calculationResult && this.calculationResult.breakdownCost) {
        return this.calculationResult.breakdownCost.summary.participantCosts.sort(
            (a, b) => (a.id < b.id ? -1 : 1)
        )
      } else {
        return []
      }
    },
    participantsPax(){
      let ad = this.participants.filter(p => p.ageType === 'adult')
      let tn = this.participants.filter(p => p.ageType === 'teenager')
      let cl = this.participants.filter(p => p.ageType === 'child')
      let pax = []
      if (ad.length > 0) pax.push(`${ad.length} Adult`)
      if (tn.length > 0) pax.push(`${tn.length} Teenager`)
      if (cl.length > 0) pax.push(`${cl.length} Child`)
      return pax
    },
    findQualityLIst(){
      let i = 0;
      let list = []
      while (i < this.participants.length) {
        i++;
        list.push({
          'name': i,
          'value': i
        })
      }
      return list
    },
  },
  watch: {
    availableBanks(banks) {
      this.syncSelectedBank(banks)
    },
    'templateCurrentInvoice.currencyType'(currency, previousCurrency) {
      if (previousCurrency && currency !== previousCurrency) {
        this.resetSelectedBank()
      }
    },
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findCurrentInvoice: actionTypesInvoice.findCurrentInvoice,
      getClient: actionTypesSettings.getClient,
      findBanks: actionTypesBanks.findBanks,
      findPartners: actionTypesPartners.findPartners,
      createNewInvoices: actionTypesInvoice.createNewInvoices,
      getBehalfList: actionTypesInvoice.getBehalfList
    }),
    autoresizeAllTextarea() {
      setTimeout(() => {
        const textareas = document.querySelectorAll("[data-textarea-autoresize]")
        textareas.forEach(textarea => {
          this.textAreaAutoSizeElement(textarea)
        })
      }, 0)
    },
    textAreaAutoSizeElement(el) {
      el.style.height = "14px";
      el.style.height = (el.scrollHeight) + "px";
    },
    textAreaAutoSize(el) {
      const textarea = el.target;
      textarea.style.height = "14px";
      textarea.style.height = (textarea.scrollHeight) + "px";
    },
    changeServiceNameByType(service) {
      service.name = this.getInputTextByServiceType(service.type);
      this.autoresizeAllTextarea();
    },
    getInputTextByServiceType(type) {
      const text = this.placeholderTemplates.get(type);
      return text || 'none';
    },
    deleteServices(index, services, template) {
      this.templateCurrentInvoice.services.splice(index, 1)
      const array = template.services.map(a => a.amount)
      const arrayAmountPayable = template.services.map(a => a.amountPayable)
      const initialValue = 0;
      template.totalAmount = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
      template.totalAmountPayable = arrayAmountPayable.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
      this.autoresizeAllTextarea();
    },
    autoAddServices(){
      this.updateDatePickers()
      this.currentInvoice.services.map(s => {
        this.templateCurrentInvoice.services.push({
          name: s.name,
          quantity: s.quantity,
          price: s.price,
          startDate: s.startDate,
          endDate: s.endDate,
          amountPayable: s.amountPayable === 0 ? null : s.amountPayable,
          amountPaid: s.amountPaid,
          amount: s.amount,
          type: s.type
        })
      })
      setTimeout(() => {
        this.autoresizeAllTextarea();
      }, 1000)
    },
    addServices() {
      this.updateDatePickers()
      this.templateCurrentInvoice.services.push({
        name: "",
        quantity: 1,
        price: null,
        startDate: "",
        endDate: "",
        amountPayable: null,
        amountPaid: 0,
        amount: null,
        type: ''
      })
    },
    createDublicateInvoices() {
      if (!this.hasClientContract) return

      const fields = [...this.placeholderTemplates.values()];
      const filledFields = this.templateCurrentInvoice.services.map((service) => service.name);

      const fieldsWithError = filledFields.filter((item) => fields.includes(item));

      this.templateCurrentInvoice.services.forEach((item) => {
        item.isError = fieldsWithError.includes(item.name);
      })
      const isBankCurrencyValid = this.validateBankCurrency()

      if (fieldsWithError.length > 0 || !isBankCurrencyValid) {
        return;
      }

      this.createNewInvoices(this.templateCurrentInvoice).then(
          () => this.$router.push(
              { path: `/changeInvoice/${this.newInvoices.id }`}
          )
      )
    },
    openSelects(type = false){
      this.selects = {
        clients: false,
        [type]: !this.selects[type],
      }
    },
    parseDate(date) {
      if (!date) return
      var parts = date.match(/(\d+)/g)
      // console.log(parts)
      // console.log(new Date(parts[2], parts[1]-1, parts[0]))
      return new Date(parts[2], parts[1]-1, parts[0])
      // return new Date(format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy, MM, dd'))
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    convectorFormat(date, tag) {
      if (tag === 'deadline'){
        let data1 = this.parseDate(date)
        let data2 = new Date(this.now)
        let day1D = data1.getDate()
        let day2D = data2.getDate()
        let day1Y = data1.getFullYear()
        let day2Y = data2.getFullYear()
        let day1M = data1.getMonth()
        let day2M = data2.getMonth()
        if (date) {
          if (day1Y >= day2Y) {
            if (day1Y === day2Y) {
              if (day1M >= day2M) {
                if (day1M === day2M) {
                  if (day1D >= day2D) {
                    this.templateCurrentInvoice.deadline = date
                    this.validErrorInvoice.deadline = false
                  }else {
                    this.validErrorInvoice.deadline = true
                  }
                }
                else if (day1M > day2M) {
                  this.templateCurrentInvoice.deadline = date
                  this.validErrorInvoice.deadline = false
                }else {
                  this.validErrorInvoice.deadline = true
                }
              }
            }
            else if (day1Y > day2Y) {
              this.templateCurrentInvoice.deadline = date
              this.validErrorInvoice.deadline = false
            }else {
              this.validErrorInvoice.deadline = true
            }
          } else {
            this.validErrorInvoice.deadline = true
          }
        }
      }
      if (tag === 'dateOfPayment') this.templateCurrentInvoice.dateOfPayment = date
    },
    findCurrentSelectsQuality(services, template, totalAmount) {
      if (services.quantity === '') {
        services.quantity = 1
      }
      this.countPrice(services, template, totalAmount)
    },
    sumTotalInvoice(template) {
      const array = template.services.map(a => a.amount)

      const initialValue = 0;
      this.totalAmountCurrentInvoice = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
      return this.numberWithCommas(this.totalAmountCurrentInvoice)
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onCountPayable(services, template, index){
      this.templateCurrentInvoice.services[index].amountPayable = services.amountPayable
      this.countPayable(services, template)
    },
    countPayable: debounce((services, template) => {
      if (services.amountPayable !== '') services.amountPayable = services.amountPayable * 1

      const array = template.services.map(a => a.amountPayable)
      const initialValue = 0;
      template.totalAmountPayable = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
    }, 350),
    onCountPrice(services, template, totalAmount){
      this.countPrice(services, template, totalAmount)
    },
    countPrice: debounce((services, template, totalAmount) => {
      services.amount = services.quantity * services.price

      const array = template.services.map(a => a.amount)

      const initialValue = 0;
      totalAmount = array.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValue
      );
    }, 350),
    isCurrentPayerSelect() {
      this.isActiveSelectPayer = !this.isActiveSelectPayer
    },
    loadCurrentPayerSelect(partners) {
      this.currentPayerSelect = partners
      this.templateCurrentInvoice.payer.participant = null
      this.templateCurrentInvoice.payer.operatorId = partners.id
    },
    findCurrentPayerSelect() {
      this.templateCurrentInvoice.payer.participant = null
      this.templateCurrentInvoice.payer.operatorId = this.currentPayerSelect.id
    },
    isCurrentPayerOptionsSelect() {
      this.isActiveSelectPayerOptions = !this.isActiveSelectPayerOptions
    },

    loadCurrentPayerOptionsSelect(payer){
      this.currentPayerOptionsSelect = payer
      this.templateCurrentInvoice.payer.payerType = payer.payerType

      if (payer.payerType === 'OPERATOR') {
        this.templateCurrentInvoice.payer.participant = null
        this.templateCurrentInvoice.payer.operatorId = this.allPartners.find(p => p.id === payer.operatorId).id
        this.currentPayerSelect = this.allPartners.find(p => p.id === payer.operatorId)
      }

      if (payer.payerType === 'PARTICIPANT') {
        this.templateCurrentInvoice.payer.participant = payer.participant
        this.templateCurrentInvoice.payer.operatorId = null
      }
    },
    findCurrentPayerOptionsSelect() {
      if (this.templateCurrentInvoice.payer.payerType === 'OPERATOR') {

        this.templateCurrentInvoice.payer.participant = null
        this.templateCurrentInvoice.payer.operatorId = this.allPartners[0].id
        this.currentPayerOptionsSelect = this.templateCurrentInvoice.payer
        this.currentPayerSelect = this.allPartners.find(p => p.id === this.templateCurrentInvoice.payer.operatorId)
      }

      if (this.templateCurrentInvoice.payer.payerType === 'PARTICIPANT') {
        this.templateCurrentInvoice.payer.participant = ''
        this.templateCurrentInvoice.payer.operatorId = null
        this.currentPayerOptionsSelect = this.templateCurrentInvoice.payer
      }
    },
    findCurrentBankSelect() {
      this.currentBankSelect = this.availableBanks.find(b => b.id === this.templateCurrentInvoice.bankId)
      if (this.validErrorInvoice.bank) {
        this.validateBankCurrency()
      }
    },
    validateBankCurrency() {
      const selectedBank = this.availableBanks.find(bank => bank.id === this.templateCurrentInvoice.bankId)
      const availableCurrencies = Array.isArray(selectedBank && selectedBank.availableCurrencies)
          ? selectedBank.availableCurrencies
          : []
      const isCurrencyAvailable = Boolean(
          selectedBank &&
          availableCurrencies.includes(this.templateCurrentInvoice.currencyType)
      )

      this.validErrorInvoice.bank = !isCurrencyAvailable
      return isCurrencyAvailable
    },
    findAllBanks() {
      this.findBanks().then(() => {
        this.ensureSelectedBank(this.availableBanks)
      })
    },
    ensureSelectedBank(banks = this.availableBanks) {
      const selectedBankId = this.templateCurrentInvoice.bankId || this.currentInvoice.bankId
      const selectedBank = banks.find((bank) => bank.id === selectedBankId) || banks[0]
      this.currentBankSelect = selectedBank || {}
      this.templateCurrentInvoice.bankId = selectedBank ? selectedBank.id : null
    },
    syncSelectedBank(banks = this.availableBanks) {
      const selectedBank = banks.find((bank) => bank.id === this.templateCurrentInvoice.bankId)
      this.currentBankSelect = selectedBank || {}
      if (!selectedBank) {
        this.templateCurrentInvoice.bankId = null
      }
    },
    resetSelectedBank() {
      this.currentBankSelect = {}
      this.templateCurrentInvoice.bankId = null
    },
    findAllPartners() {
      this.findPartners().then(
          () => {
            this.loadCurrentPayerOptionsSelect(this.currentInvoice.payer),
                this.isLoadComponent = false
          }
      )
    },
    getCurrentInvoice() {
      this.findCurrentInvoice({
        id: this.$route.params.id
      }).then(
          () => {
            this.findCurrentClient()
            this.templateCurrentInvoice.deadline = this.currentInvoice.deadline
            this.templateCurrentInvoice.note = this.currentInvoice.note
            this.templateCurrentInvoice.userId = this.currentInvoice.userId
            this.templateCurrentInvoice.currencyType = this.currentInvoice.currencyType
            this.totalAmountCurrentInvoice = this.currentInvoice.totalAmount
            this.templateCurrentInvoice.clientId = this.currentInvoice.clientId
            this.templateCurrentInvoice.allowStripe = false
            this.templateCurrentInvoice.currentDeposit = this.currentInvoice.currentDeposit
            this.templateCurrentInvoice.totalAmountPayable = this.currentInvoice.totalAmountPayable
            this.templateCurrentInvoice.chargeType = this.currentInvoice.chargeType
            this.findBehalfList()
            this.autoAddServices()
            this.convectorFormat(this.currentInvoice.deadline, 'deadline')
            this.updateDatePickers()
          })
    },
    findBehalfList(){
      this.getBehalfList({
        clientId: this.currentInvoice.clientId,
        behalfOf: this.currentInvoice.behalfOf
      }).then((res) => {
        this.templateCurrentInvoice.behalfOf = res.data.filter(r => r.active === true)
      })
    },
    findCurrentClient() {
      this.getClient({
        id: this.currentInvoice.clientId
      }).then(
          () => {
            this.findAllBanks()
            this.findAllPartners()
          })
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD.MM.yyyy',
            onClose: function () {
              item.blur()
            },
            onSelect: function () {
              item.focus()
              item.blur()
            },
          })
          item.addEventListener('blur', () => {
            datePicker.hide()
          })
        })
      }, 1000)
    },
  },
  mounted() {
    this.getCurrentInvoice()

    window.addEventListener('click', (event) => {
      event.stopPropagation()
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          clients: false,
        }
      }
    })
  },
}
</script>
<style lang="scss" scoped>
.payment-on-spot__checkbox-wrapper {
  margin-bottom: 40px;
}
.resizable-textarea {
  font-size: 12px;
  width: 100%;
  height: 20px;
  line-height: 18px;
  resize: none;
  overflow: hidden;
  outline: none;
  border: none;
}
.form-control-wrap.is-error textarea{
  background: #fde8e8;
}
.movethis {
  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-bottom: 1px solid #E4E4E4;
    border-right: 1px solid #E4E4E4;
  }
  &-button {
    width: 36px;
    height: 36px;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
  }
}
.icon-movethis {
  font-size: 1.4rem;
  color: #639a05;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
}
.form-control-wrap.is-error textarea{
  background: #fde8e8;
}
.form-control-wrap.is-error {
  background: #fde8e8;
}

.invoice-bank-select--error {
  border-radius: 3px;
  background-color: rgba(244, 152, 152, 0.2);
}

.invoice-contract-error {
  max-width: 28rem;
  margin-left: 2rem;
  color: #C0392B;
  font-size: 1.2rem;
  line-height: 1.4;
  text-align: right;
}
</style>
